import { CoreModule } from '@abp/ng.core';
import { NgbModule, NgbDropdownModule, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule } from '@angular/core';
import { ThemeLeptonModule } from '@volo/abp.ng.theme.lepton';
import { CommercialUiModule } from '@volo/abp.commercial.ng.ui';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { NgxValidateCoreModule } from '@ngx-validate/core';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { OrderByPipe } from './pipes/order.pipe';
import { FilterPipe } from './pipes/filter.pipe';
import { NoDataComponent } from './nodata/nodata.component';
import { SortPipe } from './pipes/order-sort.pipe';
import { SearchListComponent } from './search-list/search-list.component';
import { FilterExactMatchPipe } from './pipes/filter-exact-match.pipe';
import { DateTimePickerComponent } from './date-time-picker/date-time-picker.component';
import { DateFormatterPipe } from './pipes/date-formatter.pipe';
import { LocalePercentPipe } from './pipes/locale-percent.pipe';
import { DateRangeSelectionPanelComponent } from './date-range-selection-panel/date-range-selection-panel.component';
import { TreeSelectModule } from './designer/tree-select/tree-select.module';
import { SidebarMenuComponent } from './sidebar-menu/sidebar-menu.component';
import { RichTextModule } from './rich-text/rich-text.module';
import { AfterIfDirective } from './after-if.directive';
import { NgxDatatableResizerDirective } from './ngx-datatable-resizer.directive';
import { IntegrationTooltipFormatterPipe } from './pipes/integration-tooltip-formatter.pipe';
import { DurationPipe } from './pipes/duration-formatter.pipe';
import { FilterPanelComponent } from './filter-panel/components/filter-panel.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FileDownloadHelperService } from './services/file-download-helper.service';
import { BlockUIModule } from 'ng-block-ui';
import { CheckBoxComponent } from './components/check-box/check-box.component';
import { FileDragDropDirective } from './directives/file-drag-drop.directive';
import { NgSelectCloseOnScrollDirective } from './directives/ng-select-close-on-scroll.directive';
import { TextareaPlaceholderFormatDirective } from './directives/textarea-placeholder-format.directive';
import { ColumnConfiguratorComponent } from './column-configurator/components/column-configurator/column-configurator.component';
import { RoutesComponent } from './routes/cai-routes/cai-routes.component';
import { TruncateWordsPipe } from './pipes/truncate-words.pipe';
import { TruncateCharactersPipe } from './pipes/truncate-characters.pipe';
import { OutboundTestCallPanelComponent } from './outbound-test-call/components/outbound-test-call-panel.component';
import { NavigationCardComponent } from './navigation-card/components/navigation-card/navigation-card.component';
import { RadioButtonGroupComponent } from './components/radio-button-group/radio-button-group.component';
import { FileSizePipe } from './pipes/file-size.pipe';
import { NzSliderModule } from 'ng-zorro-antd/slider';
import { TabsBarComponent } from './components/tabs-bar/tabs-bar.component';
import { LlmSettingsComponent } from './components/llm-settings/llm-settings.component';
import { StorageIndicatorComponent } from './components/storage-indicator/storage-indicator.component';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { FormatLargeNumberPipe } from './pipes/format-large-number.pipe';
import { FormatResponseTimePipe } from './pipes/format-response-time.pipe';
import { WebSocketService } from './chatbot/proxy/websocket.service';
import { IvrEmulatorService } from './chatbot/proxy/ivr-emulator.service';

@NgModule({
  declarations: [
    OrderByPipe,
    FilterPipe,
    DurationPipe,
    NoDataComponent,
    SortPipe,
    TruncateWordsPipe,
    TruncateCharactersPipe,
    SearchListComponent,
    FilterExactMatchPipe,
    DateTimePickerComponent,
    DateFormatterPipe,
    LocalePercentPipe,
    FormatLargeNumberPipe,
    FormatResponseTimePipe,
    AfterIfDirective,
    NgxDatatableResizerDirective,
    DateRangeSelectionPanelComponent,
    IntegrationTooltipFormatterPipe,
    SidebarMenuComponent,
    FilterPanelComponent,
    FileDragDropDirective,
    CheckBoxComponent,
    NgSelectCloseOnScrollDirective,
    TextareaPlaceholderFormatDirective,
    ColumnConfiguratorComponent,
    RoutesComponent,
    OutboundTestCallPanelComponent,
    NavigationCardComponent,
    RadioButtonGroupComponent,
    FileSizePipe,
    TabsBarComponent,
    LlmSettingsComponent,
    StorageIndicatorComponent,
  ],
  imports: [
    CoreModule,
    ThemeSharedModule,
    ThemeLeptonModule,
    CommercialUiModule,
    NgbDropdownModule,
    NgbModule,
    NgbDatepickerModule,
    NgxValidateCoreModule,
    NzSwitchModule,
    RichTextModule,
    TreeSelectModule,
    NzTabsModule,
    NzDropDownModule,
    NzDividerModule,
    BlockUIModule,
    NgSelectModule,
    DragDropModule,
    NzSliderModule,
    NzProgressModule,
  ],
  exports: [
    OrderByPipe,
    SortPipe,
    FilterPipe,
    DurationPipe,
    TruncateWordsPipe,
    TruncateCharactersPipe,
    IntegrationTooltipFormatterPipe,
    SearchListComponent,
    CoreModule,
    ThemeSharedModule,
    ThemeLeptonModule,
    CommercialUiModule,
    NgbDropdownModule,
    NgbModule,
    NzDividerModule,
    NgxValidateCoreModule,
    NzSwitchModule,
    RichTextModule,
    SidebarMenuComponent,
    NoDataComponent,
    FilterExactMatchPipe,
    DateTimePickerComponent,
    DateFormatterPipe,
    LocalePercentPipe,
    FormatLargeNumberPipe,
    FormatResponseTimePipe,
    DateRangeSelectionPanelComponent,
    AfterIfDirective,
    NgxDatatableResizerDirective,
    FilterPanelComponent,
    FileDragDropDirective,
    NgSelectCloseOnScrollDirective,
    TextareaPlaceholderFormatDirective,
    CheckBoxComponent,
    OutboundTestCallPanelComponent,
    NavigationCardComponent,
    ColumnConfiguratorComponent,
    TreeSelectModule,
    RadioButtonGroupComponent,
    FileSizePipe,
    TabsBarComponent,
    LlmSettingsComponent,
    StorageIndicatorComponent,
  ],
  providers: [
    // other providers
    WebSocketService,
    IvrEmulatorService,
    FileDownloadHelperService,
    FormatLargeNumberPipe,
    FormatResponseTimePipe,
  ],
})
export class SharedModule {}
